export const TRACKING_PROMISE_DAYS_ERROR =
  "# of Days Promised for Tracking must be a positive day value or range";

export const TRACKING_PROMISE_DAYS_PLACEHOLDER =
  "4, 4 days, 3-4, 3 to 4";

const TRACKING_PROMISE_DAYS_PATTERN =
  /^([1-9]\d*)(?:\s+days?)?(?:(?:\s*-\s*|\s+to\s+)([1-9]\d*)(?:\s+days?)?)?$/i;

export const normalizeTrackingPromiseDaysInput = (value) => {
  if (value === undefined || value === null) {
    return "";
  }

  return String(value).trim().replace(/\s+/g, " ");
};

export const isValidTrackingPromiseDays = (value) => {
  const normalizedValue = normalizeTrackingPromiseDaysInput(value);

  if (!normalizedValue) {
    return false;
  }

  const match = normalizedValue.match(TRACKING_PROMISE_DAYS_PATTERN);

  if (!match) {
    return false;
  }

  const start = Number(match[1]);
  const end = match[2] ? Number(match[2]) : null;

  return end === null || start <= end;
};

export const getTrackingPromiseDaysErrorMessage = (message) => {
  if (
    typeof message === "string" &&
    /# of days promised for tracking.*positive whole number/i.test(message)
  ) {
    return TRACKING_PROMISE_DAYS_ERROR;
  }

  return message || TRACKING_PROMISE_DAYS_ERROR;
};
